import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-x-search",
  "use": "icon-x-search-usage",
  "viewBox": "0 0 16.001 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.001 16\" id=\"icon-x-search\">\r\n  <path id=\"icon-x-search_顶部-搜索\" d=\"M15.793,14.706l-3-2.949a6.957,6.957,0,0,0-.4-9.7,7.358,7.358,0,0,0-10.254.05,6.964,6.964,0,0,0-.149,9.9l.149.15a7.436,7.436,0,0,0,9.553.651l3,2.948a.73.73,0,0,0,1.1,0,.769.769,0,0,0,0-1.05ZM1.539,7.11a5.754,5.754,0,0,1,11.5,0,5.686,5.686,0,0,1-5.752,5.6,5.656,5.656,0,0,1-5.752-5.6Z\" transform=\"translate(0 -0.006)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol